<template>
    <div class="shift-start-page page-content">
        <h2>Inicio de turno</h2>
        
        <app-shift-form :is-start="true" :is-other="isOther" />
    </div>
</template>
<script>
    import shiftsRepository from '../../../../../repositories/shifts.repository';
    import { mapGetters } from 'vuex';
    import ShiftForm from '../../ShiftForm/ShiftForm.vue';

    export default {
        components: {
            appShiftForm: ShiftForm
        },
        props: ['isOther']
    }
</script>